var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({'direction': _vm.$vs.rtl ? 'rtl' : 'ltr'})},[_c('div',{staticClass:"vx-row pt-2"},[_c('vs-button',{staticClass:"mr-2 px-3",attrs:{"size":"small","color":"success","type":"filled","icon-pack":"feather","icon":"icon-edit"},on:{"click":_vm.editRecord}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }